import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const DownloadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 21H3m15-10-6 6m0 0-6-6m6 6V3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  </SvgIcon>
);
